
import { getCurrentInstance, onMounted, reactive, ref, toRefs, watch } from 'vue'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import { DatePicker } from 'v-calendar'
import { useStore } from 'vuex'
import * as Yup from 'yup'
import { Form, Field } from 'vee-validate'
import moment from 'moment'
import SelectFetchCustom from '@/views/components/form/SelectAsyncTest.vue'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import InputSwitch from 'primevue/inputswitch'
import Paginator from '@/views/components/paginator/Paginator.vue'
import Card from 'primevue/card'
import { useRoute, useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import Details from './components/dialog/Details.vue'

export default {
  components: {
    // Dialog,
    Card,
    Form,
    Field,
    InputText,
    DatePicker,
    // SelectFetch,
    Button,
    SelectFetchCustom,
    DataTable,
    Column,
    ProgressSpinner,
    InputSwitch,
    Paginator,
    Details,
    HjpConfirmationModal
  },
  props: {
    partnerId: {
      default: () => null as any
    },
    show: {
      type: Boolean,
      default: false
    },
  },
  emits: ['hideDialog', 'reloadData'],
  setup(props: any, { emit }: any) {
    const trayekDetailEndpoint = '/management/v1/TrayekDetail'
    const partnerEndpoint = '/management/v2/Partners'
    const trayekRegularTypeId = '8e072a19-599c-45f0-a337-08dbd378cce6'
    const trayekAirportTypeId = '971ab31f-207d-4ad5-8670-d9fcb9185475'
    const { show, partnerId } = toRefs(props)
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const app = getCurrentInstance()
    const {
      $toast,
      $icon,
      $confirm
    } = app!.appContext.config.globalProperties
    const showModal = show.value
    const title = ref('Tambah')
    const isDetailOpen = ref(false)
    const dataSourceDetail = ref([]) as any
    const selectedPp = ref([]) as any
    const selectedTrayekType = ref(0)
    const selectedTrayekTypeId = ref(trayekRegularTypeId)
    const isTrayekOpen = ref(true)
    const partnerData = ref(null) as any
    const contractData = ref(null) as any
    const showTrayekDetailDialog = ref(false)
    const dataRow = ref(null) as any
    const showConfirmDialog = ref(false)

    const filters = ref({
      search: '',
      filterField: ['code'],
      pageNumber: 1,
      pageSize: 10,
      totalRecords: 0,
      custom: [['orderBy', '=', 'DepartureTime asc']] as any
    })

    const initialValues = reactive({
      StartDate: '',
      Trayek: null as any,
      Passenger: null as any,
      IsActive: false
    })

    const schema = Yup.object().shape({
      StartDate: Yup.string().required('Tanggal Mulai tidak boleh kosong'),
      // EndDate: Yup.string().required('Tanggal Berakhir tidak boleh kosong'),
      Trayek: Yup.object().required('Kelas tidak boleh kosong'),
      // Passenger: Yup.object().required('Kelas tidak boleh kosong'),
    })

    const confirmDialogDelete = reactive({
      show: false,
      title: 'Hapus Kontrak?',
      subTitle: 'Data kontrak tersebut akan dihapus dalam sistem. Yakin hapus kontrak?',
      btnSubmitTitle: 'Hapus Kontrak',
      // imgContent: require('@/assets/img/modal-confirmation/closing-stat.svg')
    })

    const onSubmitProcess = async (data: any) => {
      store.dispatch('showLoading')
      try {
        const payload = {
          TrayekId: data.Trayek?.Id,
          PassengerTypeId: data.Passenger?.Id,
          StartDate: moment(data.StartDate).format('YYYY-MM-DD'),
          IsActive: true,
          Notes: 'postOrPut'
        }
        await apiUseCase.postOrPut(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements`, contractData.value?.Id ?? null, payload).then((response) => {
          const { result, error, message } = response
          if (!error) {
            $toast.add({
              severity: 'success',
              summary: 'Kontrak Partner berhasil dibuat!',
              detail: 'Data kontrak partner telah berhasil dibuat dalam sistem',
              group: 'bc',
              closable: false,
              life: 3000
            })

            if (!contractData.value) {
              // contractData.value = result

              router.push({
                name: 'partner-agreement-form',
                params: {
                  partnerId: encryptDecriptMethods.encrypt(partnerData.value),
                  id: encryptDecriptMethods.encrypt(result.Id)
                }
              })
              // getAgreementDetail()
            }
            // eslint-disable-next-line no-use-before-define
            getAgreementData()
          } else {
            $toast.add({
              severity: 'error',
              detail: message,
              group: 'bc',
              closable: false,
              life: 3000
            })
          }
        })
      } catch (error) {
        console.log('errorSubmit', error)
      }
      store.dispatch('hideLoading')
    }

    const onSubmit = async (values: any) => {
      console.log('values', values)
      store.dispatch('showLoading')
      const filtersCek = {
        custom: [['trayekName', '=', values.Trayek?.Name]]
      }
      await apiUseCase.get(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements${returnUrlPrams(filtersCek)}`).then((response) => {
        const { error, result, message } = response
        if (!error) {
          if (result.length > 0) {
            $toast.add({
              severity: 'error',
              detail: 'Partner sudah memiliki Kontrak dengan Trayek yang dipilih',
              group: 'bc',
              closable: false,
              life: 3000
            })
          } else {
            onSubmitProcess(values)
          }
        } else {
          $toast.add({
            severity: 'error',
            detail: message,
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      })
      store.dispatch('hideLoading')
    }

    const closeDialog = () => {
      emit('hideDialog')
    }

    const getAgreementDetail = async () => {
      store.dispatch('showLoading')
      await apiUseCase.get(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements/${contractData.value?.Id}/PartnerAgreementSchedules${returnUrlPrams(filters.value)}`).then((response) => {
        const { error, result, count } = response
        if (!error) {
          console.log('listSubs', result)
          filters.value.totalRecords = count
          dataSourceDetail.value = result.map((data: any) => ({
            ...data,
            IsSelected: data.Id === '00000000-0000-0000-0000-000000000000' ? false : true
          }))
        }
      })
      store.dispatch('hideLoading')
    }

    const onChangePage = ({ page }: any) => {
      filters.value.pageNumber = page + 1
      getAgreementDetail()
    }

    const onChangeTrayekType = (val: any, setFieldValue: any) => {
      if (val === 1) {
        selectedTrayekTypeId.value = trayekAirportTypeId
      } else {
        selectedTrayekTypeId.value = trayekRegularTypeId
      }
      if (val !== selectedTrayekType.value) {
        selectedTrayekType.value = val
        // isTrayekOpen.value = false
        setFieldValue('Trayek', null)
        dataSourceDetail.value = []
        isDetailOpen.value = false
        // isTrayekOpen.value = true
      }
    }

    const defineInitialValues = () => {
      initialValues.StartDate = contractData.value.CreatedAt
      initialValues.Trayek = contractData.value?.Trayek
      if (contractData.value?.Trayek.TrayekTypeName === 'Reguler') {
        selectedTrayekType.value = 0
        selectedTrayekTypeId.value = trayekRegularTypeId
      } else {
        selectedTrayekType.value = 1
        selectedTrayekTypeId.value = trayekAirportTypeId
      }
    }

    const onAddTrayekPp = async (data: any) => {
      store.dispatch('showLoading')
      const payload = {
        PartnerId: partnerData.value?.Id,
        PartnerAgreementId: contractData.value?.Id,
        TrayekSubId: data.TrayekSubId
      }
      await apiUseCase.postWithNoId(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements/${contractData.value?.Id}/PartnerAgreementSchedules`, payload).then((response) => {
        const { error, message } = response
        if (!error) {
          $toast.add({
            severity: 'success',
            summary: 'PP berhasil ditambahkan',
            detail: 'Data PP Trayek telah berhasil ditambahkan ke dalam Kontrak',
            group: 'bc',
            closable: false,
            life: 3000
          })
          getAgreementDetail()
        } else {
          $toast.add({
            severity: 'error',
            detail: message,
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      })
      store.dispatch('hideLoading')
    }

    const onDeleteTrayekPp = async (data: any) => {
      store.dispatch('showLoading')
      await apiUseCase.delete(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements/${contractData.value?.Id}/PartnerAgreementSchedules`, data.Id).then((response) => {
        const { error, message } = response
        if (!error) {
          $toast.add({
            severity: 'success',
            summary: 'PP berhasil dihilangkan',
            detail: 'Data PP Trayek telah berhasil dihilangkan dari dalam Kontrak',
            group: 'bc',
            closable: false,
            life: 3000
          })
          getAgreementDetail()
        } else {
          $toast.add({
            severity: 'error',
            detail: message,
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      })
      store.dispatch('hideLoading')
    }

    const onSelectDetailAct = (data: any) => {
      if (!data.IsSelected) {
        $confirm.require({
          header: 'Tambah PP',
          message: 'Apakah anda yakin ingin menghilangkannya?',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            onDeleteTrayekPp(data)
          },
          reject: () => {
            data.IsSelected = !data.IsSelected
          }
        })
      } else {
        $confirm.require({
          header: 'Tambah PP',
          message: 'Apakah anda yakin ingin menambahnya?',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            onAddTrayekPp(data)
          },
          reject: () => {
            data.IsSelected = !data.IsSelected
          }
        })
      }
    }

    const closeTrayekDetailDialog = () => {
      showTrayekDetailDialog.value = false
      dataRow.value = null
    }

    const showDetailTrayek = (data: any) => {
      dataRow.value = data
      showTrayekDetailDialog.value = true
    }

    watch(() => route.params.id, (newId: any, oldId: any) => {
      console.log('route', route)
      if (route.fullPath.includes('form')) {
        if (newId && newId !== oldId) {
          contractData.value = encryptDecriptMethods.decrypt(newId)
          console.log('contractData', contractData.value)
          // title.value = 'Edit'
          // eslint-disable-next-line no-use-before-define
          getAgreementData()
          // getDetail(contractData.value)
        }
      }
    })

    const getAgreementData = async () => {
      store.dispatch('showLoading')
      const agreementId = route.params.id ? encryptDecriptMethods.decrypt(route.params.id) : null
      await apiUseCase.get(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements/${agreementId}`).then((response) => {
        console.log('resData', response)
        const { error, result } = response
        if (!error) {
          contractData.value = result
          defineInitialValues()
          getAgreementDetail()
          console.log('contractData', contractData.value)
          store.dispatch('ui/setBreadcrumbs', [
            {
              title: 'Master Partner',
              routeName: 'master-partner'
            },
            {
              title: `${partnerData.value?.Name}`,
              routeName: 'partner-agreement',
              params: { id: route.params.partnerId }
            },
            {
              title: `${route.params.id ? `Edit ${contractData.value?.TrayekName}` : 'Tambah Kontrak'}`,
              routeName: 'partner-agreement-form',
              params: { partnerId: route.params.partnerId, id: route.params.id }
            }
          ])
        }
      })
      store.dispatch('hideLoading')
    }

    const closeForm = () => {
      console.log('sss')
      router.push({
        name: 'partner-agreement',
        params: { id: route.params.partnerId }
      })
    }

    onMounted(() => {
      partnerData.value = encryptDecriptMethods.decrypt(route.params.partnerId)
      console.log('contractData', contractData.value)
      console.log('partnerId', partnerData.value)
      if (route.params.id) {
        getAgreementData()
      } else {
        store.dispatch('ui/setBreadcrumbs', [
          {
            title: 'Master Partner',
            routeName: 'master-partner'
          },
          {
            title: `${partnerData.value?.Name}`,
            routeName: 'partner-agreement',
            params: { id: route.params.partnerId }
          },
          {
            title: 'Tambah Kontrak',
            routeName: 'partner-agreement-form',
            params: { partnerId: route.params.partnerId, id: route.params.id }
          }
        ])
      }
    })

    const submitFromDialog = async () => {
      store.dispatch('showLoading')
      console.log('deleteTrayek')
      store.dispatch('hideLoading')
    }

    const onDeleteTrayek = (data: any) => {
      dataRow.value = data
      showConfirmDialog.value = true
      confirmDialogDelete.show = true
    }

    const hideDialogConfirmation = () => {
      dataRow.value = null
      showConfirmDialog.value = false
      confirmDialogDelete.show = false
    }

    return {
      showModal,
      initialValues,
      schema,
      onSubmit,
      title,
      closeDialog,
      moment,
      // dataDummy,
      // getDetail,
      dataSourceDetail,
      selectedPp,
      isDetailOpen,
      selectedTrayekType,
      filters,
      onChangePage,
      selectedTrayekTypeId,
      onChangeTrayekType,
      isTrayekOpen,
      contractData,
      onSelectDetailAct,
      showTrayekDetailDialog,
      closeTrayekDetailDialog,
      showDetailTrayek,
      dataRow,
      hideDialogConfirmation,
      onDeleteTrayek,
      confirmDialogDelete,
      showConfirmDialog,
      closeForm
    }
  }
}

